export const frontporch = [
	{
		"id": 1,
		"jump": "frontporch",
		"title": "",
		"pic": "../img/frontporch/frontporch-logo.png",
		"alt": "Front Porch Brewing Logo",
		"center": "imagewide"
	},
	{
		"id": 2,
		"jump": "frontporch1",
		"title": "Dark Remedy Beer Label",
		"pic": "../img/frontporch/dark-remedy.jpg",
		"alt": "Dark Remedy Beer Can Label Artwork",
		"center": "imagewide"
	},
	{
		"id": 3,
		"jump": "",
		"title": "",
		"pic": "../img/frontporch/dark-remedy-2.jpg",
		"alt": "Dark Remedy Beer Label Reverse Color",
		"center": "imagewide",
		"orientation": "landscape"
	},
	{
		"id": 4,
		"jump": "frontporch2",
		"title": "Devil Children Beer Label",
		"pic": "../img/frontporch/devil-children-2.jpg",
		"alt": "Devil Children Beer Can Label Artwork",
		"center": "imagewide spacing1",
		"orientation": "landscape"		
	},
	{
		"id": 5,
		"jump": "",
		"title": "",
		"pic": "../img/frontporch/devil-children.jpg",
		"alt": "Devil Children Charcoal Drawing",
		"center": "reg"
	},
]